const Refresh = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3.64265 2.95599C4.85233 1.90771 6.39996 1.3317 8.00065 1.33399C11.6827 1.33399 14.6673 4.31866 14.6673 8.00066C14.6673 9.42466 14.2207 10.7447 13.4607 11.8273L11.334 8.00066H13.334C13.3341 6.95507 13.0268 5.93253 12.4504 5.06016C11.874 4.1878 11.0539 3.5041 10.0921 3.09407C9.13027 2.68405 8.06913 2.56579 7.04062 2.754C6.01212 2.94221 5.06162 3.42859 4.30732 4.15266L3.64265 2.95599ZM12.3587 13.0453C11.149 14.0936 9.60134 14.6696 8.00065 14.6673C4.31865 14.6673 1.33398 11.6827 1.33398 8.00066C1.33398 6.57666 1.78065 5.25666 2.54065 4.17399L4.66732 8.00066H2.66732C2.66723 9.04624 2.97449 10.0688 3.55088 10.9412C4.12726 11.8135 4.94736 12.4972 5.9092 12.9072C6.87103 13.3173 7.93217 13.4355 8.96068 13.2473C9.98918 13.0591 10.9397 12.5727 11.694 11.8487L12.3587 13.0453Z"
        fill="#333333"
      />
    </svg>
  );
};

export default Refresh;
